import { Routes } from "@angular/router";
import { CustomersPageComponent } from "./customers/customers-page.component";
import { CustomerCreateComponent } from "./customers/customer-create.component";
import { CustomerDetailComponent } from "./customers/customer-detail.component";
import { EstimatePageComponent } from "./customers/estimate-page.component";
import { CustomerEditPageComponent } from "./customers/customer-edit-page.component";
import { WindowEditPageComponent } from "./rooms/window-edit-page.component";
import { SettingsPageComponent } from "./settings/settings-page.component";
import { BusinessSettingsPageComponent } from "./settings/business-settings-page.component";
import { TermsSettingsPageComponent } from "./settings/terms-settings-page.component";
import { CatalogSettingsPageComponent } from "./settings/catalog-settings-page.component";
import { CategoryListPageComponent } from "./settings/category-list-page.component";
import { BlindListPageComponent } from "./settings/blind-list-page.component";
import { BlindDetailPageComponent } from "./settings/blind-detail-page.component";
import { SuppliersPageComponent } from "./settings/suppliers-page.component";
import { HelpPageComponent } from "./help/help-page.component";
import { EmailTemplatesPageComponent } from "./email-templates/email-templates-page.component";
import { FinancesPageComponent } from "./finances/finances-page.component";
import { OrdersPageComponent } from "./orders/orders-page.component";
import { OrderDetailPageComponent } from "./orders/order-detail-page.component";
import { DraftsPageComponent } from "./drafts/drafts-page.component";
import { DraftDetailPageComponent } from "./drafts/draft-detail-page.component";
import { unsavedChangesGuard } from "./core/unsaved-changes.guard";
import { adminAuthGuard } from "./core/auth.guard";
import { LoginPageComponent } from "./login/login-page.component";
import { DashboardComponent } from "./home/dashboard.component";

export const routes: Routes = [
  {
    path: "login",
    component: LoginPageComponent,
  },
  {
    path: "",
    canActivate: [adminAuthGuard],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        component: DashboardComponent,
        data: { title: "Dashboard" },
      },

      // ── Own Jobs (manual, in-home jobs) ────────────────────────────────
      {
        path: "jobs",
        component: CustomersPageComponent,
        data: { title: "Own Jobs" },
      },
      { path: "customers", redirectTo: "jobs", pathMatch: "full" },
      {
        path: "customers/new",
        component: CustomerCreateComponent,
        data: { title: "New Job" },
      },
      {
        path: "customers/:customerId",
        component: CustomerDetailComponent,
        data: { title: "Customer" },
      },
      {
        path: "customers/:customerId/edit",
        component: CustomerEditPageComponent,
        data: { title: "Edit Customer" },
      },
      {
        path: "customers/:customerId/estimate",
        component: EstimatePageComponent,
        canDeactivate: [unsavedChangesGuard],
        data: { title: "Estimate" },
      },
      {
        path: "customers/:customerId/rooms/:roomId/windows/:windowId/edit",
        component: WindowEditPageComponent,
        data: { title: "Edit Window" },
      },

      // ── Orders (was DIY Orders) ────────────────────────────────────────
      {
        path: "orders",
        component: OrdersPageComponent,
        data: { title: "Orders" },
      },
      {
        path: "orders/:id",
        component: OrderDetailPageComponent,
        data: { title: "Order" },
      },
      { path: "diy-orders", redirectTo: "orders", pathMatch: "full" },

      // ── Drafts (live customer carts, read-only) ───────────────────────
      {
        path: "drafts",
        component: DraftsPageComponent,
        data: { title: "Drafts" },
      },
      {
        path: "drafts/:ownerId",
        component: DraftDetailPageComponent,
        data: { title: "Draft" },
      },

      // ── Catalog ────────────────────────────────────────────────────────
      {
        path: "catalog",
        component: CatalogSettingsPageComponent,
        data: { title: "Catalog" },
      },
      {
        path: "catalog/categories",
        component: CategoryListPageComponent,
        data: { title: "Categories" },
      },
      {
        path: "catalog/blinds",
        component: BlindListPageComponent,
        data: { title: "Blinds" },
      },
      {
        path: "catalog/blinds/:id",
        component: BlindDetailPageComponent,
        data: { title: "Blind" },
      },
      { path: "settings/catalog", redirectTo: "catalog", pathMatch: "full" },
      {
        path: "settings/catalog/categories",
        redirectTo: "catalog/categories",
        pathMatch: "full",
      },
      {
        path: "settings/catalog/blinds",
        redirectTo: "catalog/blinds",
        pathMatch: "full",
      },
      {
        path: "settings/catalog/blinds/:id",
        redirectTo: (route) => `/catalog/blinds/${route.paramMap.get("id")}`,
      },

      // ── Settings ───────────────────────────────────────────────────────
      {
        path: "settings",
        component: SettingsPageComponent,
        data: { title: "Settings" },
      },
      {
        path: "settings/business",
        component: BusinessSettingsPageComponent,
        data: { title: "Business & Estimates" },
      },
      {
        path: "settings/terms",
        component: TermsSettingsPageComponent,
        data: { title: "Terms & Conditions" },
      },
      {
        path: "settings/suppliers",
        component: SuppliersPageComponent,
        data: { title: "Suppliers" },
      },
      {
        path: "settings/email-templates",
        component: EmailTemplatesPageComponent,
        data: { title: "Email Templates" },
      },
      {
        path: "email-templates",
        redirectTo: "settings/email-templates",
        pathMatch: "full",
      },

      // ── Finances & Help ────────────────────────────────────────────────
      {
        path: "finances",
        component: FinancesPageComponent,
        data: { title: "Finances" },
      },
      { path: "help", component: HelpPageComponent, data: { title: "Help" } },
    ],
  },
  { path: "**", redirectTo: "" },
];
